import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';
import DashboardService from 'api/dashboard/DashboardService';
import { FleetDriverAssignmentDashboardDto } from 'api/dashboard/dtos/FleetDriverAssignmentDashboardDto';
import LoadingSpinner from 'common/components/loading/LoadingSpinner';
import Box from 'common/components/box/Box';
import ProportionalBar from 'common/components/charts/ProportionalBar';
import tableStyles from '../dashboardTable/DashboardTable.module.scss';
import WidgetNoData from '../components/WidgetNoData';
import styles from './VehiclesDriverAssignment.module.scss';

const VehiclesDriverAssignment = () => {
	const { t } = useTranslation();
	const { addToast } = useToasts();
	const [data, setData] = useState<FleetDriverAssignmentDashboardDto | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		let cancelled = false;
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const result = await DashboardService.getFleetDriverAssignment({});
				if (!cancelled) setData(result);
			} catch {
				if (!cancelled) addToast(t('common.messages.error_load_info'), { appearance: 'error' });
			} finally {
				if (!cancelled) setIsLoading(false);
			}
		};
		fetchData();
		return () => { cancelled = true; };
	}, []);

	if (!data && !isLoading) return null;

	const total = data ? data.withDriver + data.withoutDriver : 0;

	if (total === 0) {
		return (
			<Box className={tableStyles.container} title={t('dashboard.vehicles_driver_assignment') as string} subTitleTooltip={t('dashboard.vehicles_driver_assignment_tooltip' as any) as string}>
				{isLoading
					? <div className={styles.centerAlign}><LoadingSpinner /></div>
					: <WidgetNoData />
				}
			</Box>
		);
	}

	const items = [
		{ label: t('dashboard.with_driver') as string, value: data!.withDriver, color: '#02c7c7' },
		{ label: t('dashboard.without_driver') as string, value: data!.withoutDriver, color: '#9ca3af' },
	];

	return (
		<Box className={tableStyles.container} title={t('dashboard.vehicles_driver_assignment') as string} subTitleTooltip={t('dashboard.vehicles_driver_assignment_tooltip' as any) as string}>
			{isLoading
				? <div className={styles.centerAlign}><LoadingSpinner /></div>
				: <ProportionalBar items={items} />
			}
		</Box>
	);
};

export default VehiclesDriverAssignment;
